<template>
	<div class="global-processing-overlay">
		<div class="overlay-text">
			<div class="modal-content shadow">
				<div class="modal-body p-4 px-5">
				<h3 id="global-processing-overlay-message" class="text-center" v-html="message">
				</h3>
				<div class="loader-container text-center">
					<img id="global-processing-overlay-loader-image" src="https://assets.lotusai.co/portal/images/logo-radial-2.gif" style="height: 80px; width: auto;" />
				</div>
			</div>
			</div>
		</div>
	</div>
</template>





<script>
export default {
	props: {
		
		customMessage: {
			type: String,
			default: "",
			required: false
		},
	},


	computed: {

		message()
		{
			const showMessag = this.customMessage ? this.customMessage : "Please wait";

			// console.log("GPO.this.customMessage():", this.customMessage);
			// console.log("GPO.message():", showMessag);
			return showMessag;
			
		}
	},
}
</script>





<style scoped>
/* REf: https://loading.io/css/ */
</style>